// removed by extract-text-webpack-plugin
module.exports = {"small":"(min-width:600px)","medium":"(min-width:768px)","large":"(min-width:1200px)","device":"laptop__device___2YWFP","deviceContent":"laptop__deviceContent___3L-SW","deviceScreen":"laptop__deviceScreen___3oHGo","img":"laptop__img___5P5LZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Laptop/laptop.css
// module id = 159
// module chunks = 0